'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import {
  coloringStyles,
  flexContainerStyles,
  layoutStyles,
  positioningStyles,
  sizingStyles,
  spacingStyles
} from '../_support'

// lib
import { themedView } from '../_support'

/* -----------------------------------------------------------------------------
 * Cover
 * -------------------------------------------------------------------------- */

export const ThemedCover = themedView(
  'Cover',
  coloringStyles,
  flexContainerStyles,
  layoutStyles,
  positioningStyles,
  sizingStyles,
  spacingStyles
)

export type ThemedCoverProps = React.ComponentProps<typeof ThemedCover>

export type CoverProps = ThemedCoverProps & {}

const Cover = React.forwardRef<HTMLElement, CoverProps>((props, ref) => {
  return (
    <ThemedCover
      ref={ref}
      position='absolute'
      top={0}
      left={0}
      right={0}
      bottom={0}
      {...props}
    />
  )
})

export default Cover
